/**
 * Sistema para forzar actualización de la app
 */

const APP_VERSION = '1.0.7';
const VERSION_CHECK_INTERVAL = 30000; // Verificar cada 30 segundos

class ForceUpdateService {
  constructor() {
    this.checkInterval = null;
    this.hasShownUpdatePrompt = false;
  }

  /**
   * Iniciar verificación de versión
   */
  start() {
    // Verificar versión guardada
    const savedVersion = localStorage.getItem('app_version');

    if (savedVersion !== APP_VERSION) {
      console.log(`Nueva versión detectada: ${savedVersion} → ${APP_VERSION}`);
      this.showUpdatePrompt();
    } else {
      console.log(`Versión actual: ${APP_VERSION}`);
    }

    // Guardar versión actual
    localStorage.setItem('app_version', APP_VERSION);

    // Verificar periódicamente si hay nueva versión en el servidor
    this.checkInterval = setInterval(() => {
      this.checkForUpdates();
    }, VERSION_CHECK_INTERVAL);

    // Verificar Service Worker
    this.checkServiceWorker();
  }

  /**
   * Verificar si hay actualizaciones disponibles
   */
  async checkForUpdates() {
    try {
      // Hacer request con cache-busting
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store'
      });

      if (response.ok) {
        const data = await response.json();

        if (data.version !== APP_VERSION) {
          console.log(`Nueva versión disponible: ${data.version}`);
          this.showUpdatePrompt();
        }
      }
    } catch (error) {
      console.error('Error al verificar actualizaciones:', error);
    }
  }

  /**
   * Verificar si Service Worker está registrado
   */
  async checkServiceWorker() {
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.getRegistration();

        if (!registration) {
          console.warn('⚠️ Service Worker NO registrado. Registrando ahora...');
          await navigator.serviceWorker.register('/service-worker.js');
          console.log('✓ Service Worker registrado exitosamente');
        } else {
          console.log('✓ Service Worker ya registrado');

          // Forzar actualización del Service Worker
          registration.update();
        }
      } catch (error) {
        console.error('Error al verificar Service Worker:', error);
      }
    }
  }

  /**
   * Mostrar prompt de actualización
   */
  showUpdatePrompt() {
    if (this.hasShownUpdatePrompt) {
      return;
    }

    this.hasShownUpdatePrompt = true;

    const message = '🚀 Nueva versión disponible!\n\n' +
                   'Para mejorar el tracking GPS en segundo plano,\n' +
                   'la app se recargará automáticamente en 3 segundos.\n\n' +
                   'Presiona OK para actualizar ahora.';

    const userConfirmed = window.confirm(message);

    if (userConfirmed) {
      this.forceReload();
    } else {
      // Recargar automáticamente después de 3 segundos
      setTimeout(() => {
        this.forceReload();
      }, 3000);
    }
  }

  /**
   * Forzar recarga completa
   */
  forceReload() {
    console.log('Forzando recarga de la aplicación...');

    // Limpiar Service Worker cache
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      });
    }

    // Limpiar todos los caches
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }

    // Recargar con force refresh
    window.location.reload(true);
  }

  /**
   * Detener verificación
   */
  stop() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }
}

export default new ForceUpdateService();
